<div></div>
<span mat-dialog-title class="d-flex justify-content-between m-0 dialog-title">
  <span class="mat-subtitle-2">{{this.term || ''}}</span>
  <mat-icon (click)="close()">cancel</mat-icon>
</span>
<div mat-dialog-content class="dialog-content" fxLayout="column">
  <markdown #mk [data]="this.definition" (ready)="lh.wireInsertedLinks(mk.element)" class="mat-typography"></markdown>
</div>
